import { render, staticRenderFns } from "./QuotationManagement.vue?vue&type=template&id=68629b15"
import script from "./QuotationManagement.vue?vue&type=script&lang=ts"
export * from "./QuotationManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports